export const modularLibraryCollectibleCopy = {
  en: {
    title: 'Collectible',
    close: 'Close collectible preview',
    done: 'Done',
    unlockedBy: 'Unlocking achievement',
    collectionSource: 'Collection source',
    achievementUnavailable: 'Achievement unavailable',
    acquired: 'Acquired',
    dateUnavailable: 'Date unavailable',
    shelfCapacity: 'These items need more shelf space.',
    demo: 'Demo display',
    demoNote:
      'This display is a prototype sample. Its achievement and acquisition details are not connected to your account.',
    names: {
      lamp: 'Art Deco reading lamp',
      owl: 'Soapstone owl',
      'owl-white': 'Porcelain owl',
      sphere: 'Armillary sphere',
      compass: 'Brass compass',
      pen: 'Reading pen',
      badge: 'Display badges',
      heartleaf: 'Heartleaf vine',
      'string-of-hearts': 'String of hearts',
      fern: 'Soft fern',
    },
    plantDescriptions: {
      heartleaf: 'Broad heart-shaped leaves in soft shades of green.',
      'string-of-hearts': 'Slender vines dotted with little heart-shaped leaves.',
      fern: 'A full crown of softly rounded fronds.',
    },
    plantCustomization: {
      plant: 'Plant',
      pot: 'Pot colour',
      length: 'Length',
      ivory: 'Ivory',
      sage: 'Sage',
      collection: 'Demo collection',
      allLengths: 'Each plant includes all three lengths.',
      contained: 'Contained',
      oneShelf: 'One shelf below',
      twoShelves: 'Two shelves below',
      overhangHint: 'Books behind the trailing leaves still open with a tap.',
    },
    open: 'View {{name}}',
  },
  sk: {
    title: 'Zberateľský predmet',
    close: 'Zavrieť náhľad predmetu',
    done: 'Hotovo',
    unlockedBy: 'Úspech na odomknutie',
    collectionSource: 'Pôvod predmetu',
    achievementUnavailable: 'Úspech nie je dostupný',
    acquired: 'Získané',
    dateUnavailable: 'Dátum nie je dostupný',
    shelfCapacity: 'Tieto predmety potrebujú viac miesta na polici.',
    demo: 'Ukážkový predmet',
    demoNote:
      'Tento predmet je ukážkou v prototype. Údaje o úspechu a získaní nie sú prepojené s vaším účtom.',
    names: {
      lamp: 'Čitateľská lampa v štýle art deco',
      owl: 'Mastencová sova',
      'owl-white': 'Porcelánová sova',
      sphere: 'Armilárna sféra',
      compass: 'Mosadzný kompas',
      pen: 'Čitateľské pero',
      badge: 'Ukážkové odznaky',
      heartleaf: 'Srdcolistý filodendron',
      'string-of-hearts': 'Šnúra sŕdc',
      fern: 'Jemná papraď',
    },
    plantDescriptions: {
      heartleaf: 'Široké srdcovité listy v jemných odtieňoch zelenej.',
      'string-of-hearts': 'Tenké výhonky posiate drobnými srdcovitými listami.',
      fern: 'Bohatá koruna jemne zaoblených listov.',
    },
    plantCustomization: {
      plant: 'Rastlina',
      pot: 'Farba kvetináča',
      length: 'Dĺžka',
      ivory: 'Slonovinová',
      sage: 'Šalviová',
      collection: 'Ukážková zbierka',
      allLengths: 'Každá rastlina zahŕňa všetky tri dĺžky.',
      contained: 'V priehradke',
      oneShelf: 'O jednu policu nižšie',
      twoShelves: 'O dve police nižšie',
      overhangHint: 'Knihy za prevísajúcimi listami stále otvoríte ťuknutím.',
    },
    open: 'Zobraziť: {{name}}',
  },
  cs: {
    title: 'Sběratelský předmět',
    close: 'Zavřít náhled předmětu',
    done: 'Hotovo',
    unlockedBy: 'Úspěch pro odemknutí',
    collectionSource: 'Původ předmětu',
    achievementUnavailable: 'Úspěch není dostupný',
    acquired: 'Získáno',
    dateUnavailable: 'Datum není dostupné',
    shelfCapacity: 'Tyto předměty potřebují více místa na polici.',
    demo: 'Ukázkový předmět',
    demoNote:
      'Tento předmět je ukázkou v prototypu. Údaje o úspěchu a získání nejsou propojeny s vaším účtem.',
    names: {
      lamp: 'Čtenářská lampa ve stylu art deco',
      owl: 'Mastková sova',
      'owl-white': 'Porcelánová sova',
      sphere: 'Armilární sféra',
      compass: 'Mosazný kompas',
      pen: 'Čtenářské pero',
      badge: 'Ukázkové odznaky',
      heartleaf: 'Srdcolistý filodendron',
      'string-of-hearts': 'Řetízek srdcí',
      fern: 'Jemná kapradina',
    },
    plantDescriptions: {
      heartleaf: 'Široké srdčité listy v jemných odstínech zelené.',
      'string-of-hearts': 'Tenké výhony poseté drobnými srdčitými listy.',
      fern: 'Bohatá koruna jemně zaoblených listů.',
    },
    plantCustomization: {
      plant: 'Rostlina',
      pot: 'Barva květináče',
      length: 'Délka',
      ivory: 'Slonovinová',
      sage: 'Šalvějová',
      collection: 'Ukázková sbírka',
      allLengths: 'Každá rostlina zahrnuje všechny tři délky.',
      contained: 'V přihrádce',
      oneShelf: 'O jednu polici níže',
      twoShelves: 'O dvě police níže',
      overhangHint: 'Knihy za převisajícími listy stále otevřete klepnutím.',
    },
    open: 'Zobrazit: {{name}}',
  },
} as const;
